module.exports = __webpack_public_path__ + "assets/4edc6cf30efa0fde966424b6436f19eb.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_1.mp3
 ** module id = 38
 ** module chunks = 0
 **/